import { useEffect, useState } from 'react'

interface UseDestroyProps {
  isVisible: boolean
  delay?: number
}

const useDestroy = ({ isVisible, delay = 300 }: UseDestroyProps) => {
  const [isDestroyed, setIsDestroyed] = useState(true)

  useEffect(() => {
    if (isVisible) setIsDestroyed(false)
    else setTimeout(() => setIsDestroyed(true), delay)
  }, [delay, isVisible])

  return { isDestroyed }
}

export default useDestroy
